<form [formGroup]="shareProductAccountingForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-radio-group
      class="flex-98 layout-row gap-5percent layout-column.lt-md radio-group-spacing"
      formControlName="accountingRule"
    >
      @for (accountingRule of accountingRuleData; track accountingRule; let i = $index) {
        <mat-radio-button [value]="i + 1">
          {{ 'labels.accounting.' + accountingRule | translate }}
        </mat-radio-button>
      }
    </mat-radio-group>

    <mat-divider class="flex-98"></mat-divider>

    @if (shareProductAccountingForm.value.accountingRule === 2) {
      <div class="flex-fill layout-row-wrap gap-2percent responsive-column">
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Assets' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="shareProductAccountingForm.controls.shareReferenceId"
          [glAccountList]="assetAccountData"
          [required]="true"
          [inputLabel]="'Share reference'"
        >
        </LOSx-gl-account-selector>
        <mat-divider class="flex-98"></mat-divider>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Liabilities' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="shareProductAccountingForm.controls.shareSuspenseId"
          [glAccountList]="liabilityAccountData"
          [required]="true"
          [inputLabel]="'Share suspense control'"
        >
        </LOSx-gl-account-selector>
        <mat-divider class="flex-98"></mat-divider>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Share Equity' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="shareProductAccountingForm.controls.shareEquityId"
          [glAccountList]="equityAccountData"
          [required]="true"
          [inputLabel]="'Equity'"
        >
        </LOSx-gl-account-selector>
        <mat-divider class="flex-98"></mat-divider>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Income' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="shareProductAccountingForm.controls.incomeFromFeeAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from fees'"
        >
        </LOSx-gl-account-selector>
      </div>
    }
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext [disabled]="!shareProductFormValid">
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
